module.exports = __webpack_public_path__ + "img/upload01.eb583644.png";